import React from 'react';

import Text from 'admin/components/common/Text';

import css from './CreateStoryModal.scss';

type Props = {
	children: React.ReactNode;
};

const WizardTitle: React.FC<Props> = ({ children }) => (
	<Text tag="h1" className={css.wizardTitle} size={Text.size.subheading} weight={Text.weight.semibold}>
		{children}
	</Text>
);

export default WizardTitle;
